import { render, staticRenderFns } from "./Point.vue?vue&type=template&id=de27c558&scoped=true&lang=pug&"
import script from "./Point.vue?vue&type=script&lang=js&"
export * from "./Point.vue?vue&type=script&lang=js&"
import style0 from "./Point.vue?vue&type=style&index=0&id=de27c558&prod&lang=scss&scoped=true&"
import style1 from "./Point.vue?vue&type=style&index=1&id=de27c558&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de27c558",
  null
  
)

export default component.exports